import React from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations'
import GridBlock from 'components/GridBlock';
import Loading from "components/Loading";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import DateFormats from "constants/DateFormats";
import WorkableIconPreviewButton from "components/button/WorkableIconPreviewButton";
import moment from "moment";
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles(theme => ({
    lpColumn: theme.components.table.lpColumn,
    dateColumn: theme.components.table.dateTimeColumn,
    buttonColumn: theme.components.table.buttonColumn,
}))

function HistoryListPopup(
    {
        historyList,
        selectElem,
        selectedElem
    }) {
    const classes = useStyle();
    return (
        <>
            {!historyList ?
                <Loading/>
                :
                <GridBlock
                    column
                    alignItems='center'
                >
                    <SimpleTable
                        headers={
                            [
                                Tr('column_lp'),
                                Tr('last_save_date'),
                                Tr('changing_person'),
                                ''
                            ]
                        }
                        items={
                            historyList.map((elem, i, arr) => ([
                                `${arr.length - i}`,
                                moment(elem.dateInserted).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT),
                                `${elem.user.firstName} ${elem.user.lastName}` + (elem.user.replacedUser ? ` (${Tr('in_deputy_of')} ${elem.user.replacedUser.firstName} ${elem.user.replacedUser.lastName})` : ""),
                                <WorkableIconPreviewButton onClick={() => selectElem(elem)} disabled={!!selectedElem}
                                                           working={elem.identity === selectedElem?.identity}/>
                            ]))
                        }
                        columnClasses={[
                            classes.lpColumn,
                            classes.dateColumn,
                            undefined,
                            classes.buttonColumn
                        ]}
                    />

                    {historyList.length === 0 && <Typography>{Tr('empty_history')}</Typography>}

                </GridBlock>
            }
        </>
    )
}

HistoryListPopup.propTypes = {
    classes: PropTypes.any,
}

export default HistoryListPopup;
